import Cookies from 'js-cookie'
import {
  getContactArrayByType,
  moreMagicalSortingByTheInternalExternalUserStuff,
} from '../../../components/Navigation/Footer/whole-sale-sorter'

export const getWholesalerFromcookies = () => {
  const RM_data = {
    preferredFirstNm: Cookies.get('CM_RM_NAME_INST'),
    emailId: Cookies.get('CM_RM_EML_INST'),
    phoneNbr: Cookies.get('CM_RM_PH_INST'),
    titleCd: 'My Relationship Manager',
  }
  return RM_data
}
export const findAdvisor = (value, emailId) => {
  let advisorProfile

  value.forEach((areaName) => {
    areaName.salesContactInfo.forEach((advisor) => {
      if (advisor.emailId === emailId) {
        advisorProfile = advisor
      }
    })
  })

  return advisorProfile
}

export const getDisplayableWholeSalers = (profile) => {
  let wholeSalersToDisplay = []

  // start with primary
  if (profile) {
    const primarySalesContactInfo = getContactArrayByType(
      profile.salesContactByChannel,
      'Y'
    )

    if (primarySalesContactInfo && primarySalesContactInfo.length > 0) {
      // we need to sort the primaries...
      primarySalesContactInfo[0].salesContactInfo.sort(
        moreMagicalSortingByTheInternalExternalUserStuff
      )
      wholeSalersToDisplay =
        primarySalesContactInfo[0].salesContactInfo.slice(0)
    }

    return wholeSalersToDisplay
  }
}
